import { combineReducers } from "@reduxjs/toolkit";

// Import your feature reducers here
// import companyReducer from '../features/company/companySlice';

const rootReducer = combineReducers({
  // Add your reducers here
  // company: companyReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
